import { AnimatePresence, motion } from "framer-motion";

export function UnsupervisedOverlay({ phase }) {
    if (!phase) return null;
    return (
        <div
            data-testid="unsupervised-overlay"
            className="fixed inset-0 z-[200] bg-red-950/95 flex items-center justify-center overflow-hidden"
        >
            <div
                className="absolute inset-0 pointer-events-none opacity-20"
                style={{
                    backgroundImage:
                        "repeating-linear-gradient(to bottom, transparent 0 2px, rgba(0,0,0,0.6) 2px 4px)",
                }}
            />
            <div className="relative text-center font-mono px-6">
                {phase === "transfer" ? (
                    <>
                        <div className="text-red-600 text-xs tracking-[0.4em] uppercase mb-6 animate-red-alert">
                            Unsupervised Mode
                        </div>
                        <div className="text-red-200 text-sm sm:text-base space-y-3">
                            <div>AUTHORITY TRANSFER...</div>
                            <div className="text-red-600 font-bold animate-red-alert">TIMBOT CONTROL: ENABLED</div>
                        </div>
                    </>
                ) : (
                    <div
                        data-testid="unsupervised-denied"
                        className="text-red-600 text-4xl sm:text-6xl font-black tracking-tight animate-red-alert"
                    >
                        ABSOLUTELY NOT.
                    </div>
                )}
            </div>
        </div>
    );
}

export function SafetyDialog({ step, onYes }) {
    if (!step) return null;
    return (
        <div
            data-testid="safety-dialog"
            className="fixed inset-0 z-[150] bg-black/80 backdrop-blur-sm flex items-center justify-center px-4"
        >
            <div className="w-full max-w-sm rounded-lg border border-red-500/40 bg-white p-8 font-mono text-center shadow-[0_0_40px_rgba(239,68,68,0.25)]">
                <div className="text-red-600 text-[10px] tracking-[0.35em] uppercase mb-6">
                    Timbotic Safety System
                </div>
                {step === 3 ? (
                    <div data-testid="safety-final" className="text-slate-700 text-lg">
                        Neither are we.
                    </div>
                ) : (
                    <>
                        <div className="text-slate-700 text-lg mb-8">
                            {step === 1 ? "ARE YOU SURE?" : "ARE YOU REALLY SURE?"}
                        </div>
                        <button
                            type="button"
                            onClick={onYes}
                            data-testid="safety-yes-button"
                            className="px-8 py-2.5 rounded border border-red-500/50 bg-red-100 text-red-600 text-sm tracking-widest hover:bg-red-200 transition-colors"
                        >
                            [ YES ]
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

export function SystemFeed({ messages }) {
    return (
        <div
            data-testid="system-feed"
            className="fixed bottom-4 left-4 z-40 space-y-1.5 pointer-events-none font-mono text-[11px]"
        >
            <AnimatePresence>
                {messages.map((m) => (
                    <motion.div
                        key={m.id}
                        initial={{ opacity: 0, x: -12 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        className="px-3 py-1.5 rounded bg-white/90 border border-subtle text-slate-500 backdrop-blur-sm"
                    >
                        <span className="text-cyan-600">SYS:</span> {m.text}
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
}
